
import { component } from '@/helpers/vueTyped';

export default component()({
  name: 'repeat',
});

export const repeat = (
  times: number,
  element: (index: number) => JSX.Element,
) => {
  return new Array(times).fill(undefined).map((_, idx) => element(idx));
};

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7062537a/Repeat.vue" });